import { render, staticRenderFns } from "./HbMetric.vue?vue&type=template&id=33f1b018&scoped=true"
import script from "./HbMetric.vue?vue&type=script&lang=js"
export * from "./HbMetric.vue?vue&type=script&lang=js"
import style0 from "./HbMetric.vue?vue&type=style&index=0&id=33f1b018&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f1b018",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33f1b018')) {
      api.createRecord('33f1b018', component.options)
    } else {
      api.reload('33f1b018', component.options)
    }
    module.hot.accept("./HbMetric.vue?vue&type=template&id=33f1b018&scoped=true", function () {
      api.rerender('33f1b018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/hubee/HbMetric.vue"
export default component.exports